import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { ProfileFollowList } from '@core/Areas/BetLoop/Components/ProfileFollowList'
import { betLoopPrincipleProfileQuery } from '@core/Areas/BetLoop/helpers/queries'
import { FollowListPageLoader } from '@core/Areas/BetLoop/Components/ProfileFollowList/Components/FollowListPageLoader'

export const MyProfileFollowListPage = () => {
  const { data, isLoading } = useQuery(betLoopPrincipleProfileQuery)

  if (isLoading || !data) {
    return <FollowListPageLoader />
  }

  return <ProfileFollowList profile={data} />
}
